/**
 * Enterprise Landing Page
 * NEVCO logo + "VIDEO PRO ONLINE SIMULATOR" + ENTER TRAINING + BROADCAST SIMS link
 */

import { navigate } from '../router';

export function renderLanding(container: HTMLElement): void {
  container.innerHTML = `
    <div class="enterprise-page">
      <a href="https://www.nevco.com" target="_blank" rel="noopener noreferrer">
        <img src="/assets/enterprise/nevco-logo.png" alt="NEVCO Logo" class="landing-logo" />
      </a>
      <h1>
        <span>VIDEO PRO</span>
        <span>ONLINE SIMULATOR</span>
      </h1>
      <button class="ent-btn" id="ent-start-session">ENTER TRAINING</button>
      <a href="https://www.broadcastsims.com"
         class="ent-btn-link"
         target="_blank"
         rel="noopener noreferrer">BROADCAST SIMS</a>
    </div>
  `;

  container.querySelector('#ent-start-session')!
    .addEventListener('click', () => navigate('/sessions'));
}
